import { ArrowForwardIos } from "@mui/icons-material";
import { alpha, Box, Button, CircularProgress, ListItemButton, ListItemText, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { PageContext } from "./pages";
import { useRestCall } from "./rest";

export function UListItemButton(props) {
    const cmdPage = useContext(PageContext)
    const { page, onClick, ...rest } = props;

    var defOnClick = onClick || undefined;

    if (page && cmdPage) {
        defOnClick = () => cmdPage.setPage(page);
    }

    return <ListItemButton
        onClick={defOnClick}
        {...rest}>
        {props.children}
    </ListItemButton>
}

export function UButton(props) {
    const cmdPage = useContext(PageContext)
    const { sx, call, payload, onClick, onCall, page, ...rest } = props;
    const [defLoading, setDefLoading] = useState()

    var defOnClick = onClick;

    if (page && cmdPage) {
        defOnClick = () => cmdPage.setPage(page);
    }

    if (call) {
        const intCall = onCall || (page ? () => cmdPage.setPage(page) : onClick);
        var defCall = intCall
        return <URestButton
            call={call}
            payload={payload}
            onComplete={defCall}
            {...rest}
            sx={sx}>
            {props.children}
        </URestButton>
    }
    return <ULoadingButton
        onClick={defOnClick}
        loading={defLoading}
        {...rest}
        sx={sx}>
        {props.children}
    </ULoadingButton>
}

function ULoadingButton(props) {
    const { disabled, loading, loadingSize, type, confirm, onClick, ...rest } = props;
    const content = <Box sx={{ visibility: loading ? 'hidden' : 'visible' }}>{props.children}</Box>;
    const contentLoading = <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, textAlign: 'center' }}>
        <Box sx={{ display: 'inline-flex', alignItems: 'center', height: '100%' }}>
            <CircularProgress size={loadingSize || 14} color="inherit" />
        </Box>
    </Box>;

    const ButtonType = type || Button;
    var doClickFun = onClick;
    if (confirm && onClick) {
        doClickFun = (e) => { if (window.confirm(confirm)) { onClick(e) } }
    }

    return <ButtonType onClick={doClickFun} disabled={disabled || loading} {...rest} >
        <Box sx={{ position: 'relative' }}>
            {content}{loading && contentLoading}
        </Box>
    </ButtonType>
}

function URestButton(props) {
    const { call, payload, onComplete, onError, orderLoading, ...rest } = props;
    const [doCall, loading] = useRestCall(onComplete, onError)

    return <ULoadingButton loading={orderLoading || loading} onClick={() => doCall(call, payload)} {...rest}>
        {props.children}
    </ULoadingButton>
}